'use client';

import { seedChatbotRegistry } from '../utils/chatbot-registry';

/**
 * Component that initializes the chatbot widget registry at module load time.
 * This must be called early in the app lifecycle to register all widget components.
 * 
 * Note: We seed the registry at module load time (not in useEffect) to avoid race conditions
 * where messages might try to render before the registry is ready.
 */

// Seed the registry immediately when this module loads
seedChatbotRegistry();

export default function ChatbotRegistryInitializer() {
  return null; // This component doesn't render anything, the registry is already seeded
}
